import { render, staticRenderFns } from "./SubTable.vue?vue&type=template&id=504ad01c&"
import script from "./SubTable.vue?vue&type=script&lang=ts&"
export * from "./SubTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports